/**
 * Generated by orval v8.5.3 🍺
 * Do not edit manually.
 * wedofi
 * A RESTful API. 🔒 Protected endpoints require authentication via secure HTTP-only cookies. Authentication is handled automatically by Better Auth after login.
 * OpenAPI spec version: 1.0.47
 */

/**
 * Periodicidade da compra automática. WEEKLY=7d, MONTHLY=30d (simplificação MVP, dias UTC). HALF_HOURLY=30min e MINUTELY=1min são **apenas para testes** (exigem a feature flag `dcai.fast_cycles.enabled` ativa). BIWEEKLY e QUARTERLY foram **descontinuadas** — rejeitadas para novos planos (`400`), mas planos antigos seguem ciclando.
 */
export type CreateDcaiPlanDTOFrequency = typeof CreateDcaiPlanDTOFrequency[keyof typeof CreateDcaiPlanDTOFrequency];


export const CreateDcaiPlanDTOFrequency = {
  WEEKLY: 'WEEKLY',
  BIWEEKLY: 'BIWEEKLY',
  MONTHLY: 'MONTHLY',
  QUARTERLY: 'QUARTERLY',
  HALF_HOURLY: 'HALF_HOURLY',
  MINUTELY: 'MINUTELY',
} as const;
